
import React, { Component } from 'react';
import axios from "axios";

import './Sandbox.css';

class Sandbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      formData: {
        lastName: '',
        firstName: '',
        secondName: '',
        phone: '',
        dateOfBirth: '',
        passportFile: null,
        cryptoAddress: '',
        walletType: '',
        walletName: '',
        exchangeName: '',
        cryptocurrency: '',
        amount: ''
      },
      transactionData: {
        type: '',
        cryptoAmount: '',
        transactionId: '',
        atmCode: '',
        qrAddress: ''
      },
      exchanges: [
        'Binance',
        'Coinbase',
        'Kraken',
        'Bittrex',
        'Luno',
        'VALR',
        'AltCoinTrader'
      ],
      cryptocurrencies: [
        'Bitcoin (BTC)',
        'Ethereum (ETH)'
      ]
    };
  }

  handleInputChange = (field, value) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [field]: value
      }
    });
  };

  handleFileUpload = (event) => {
    const file = event.target.files[0];
    this.setState({
      formData: {
        ...this.state.formData,
        passportFile: file
      }
    });
  };

  nextStep = () => {
    if (this.state.currentStep == 1 && this.state.formData.walletName =='' ) {
      this.setState({
        formData: {
          ...this.state.formData,
          ['walletName']: this.state.formData.firstName + ' ' + this.state.formData.lastName
        }
      });
    }
    this.setState({ currentStep: this.state.currentStep + 1 });
  };

  prevStep = () => {
    this.setState({ currentStep: this.state.currentStep - 1 });
  };

  handleBuy = () => {
    this.setState({ 
      currentStep: 5,
      transactionData: {
        ...this.state.transactionData,
        type: 'buy'
      }
    });
  };

  handleSell = () => {
    this.setState({ 
      currentStep: 5,
      transactionData: {
        ...this.state.transactionData,
        type: 'sell'
      }
    });
  };

  posttosrver = () => {
    let preformData = new FormData();
    // Append all items from this.state.formData
    Object.keys(this.state.formData).forEach(key => {
      preformData.append(key, this.state.formData[key]);
    });

    // Append all items from this.state.transactionData
    Object.keys(this.state.transactionData).forEach(key => {
      preformData.append(key, this.state.transactionData[key]);
    });

    const preresponse =  axios.post("/api/sandbox/tx", preformData);


  }
  
  processBuy = async () => {
    const cryptoAmount = (parseFloat(this.state.formData.amount) / 850000).toFixed(8); // Mock BTC rate
    const transactionId = 'TXN' + Math.random().toString(36).substr(2, 9).toUpperCase();
    
    await this.setState({
      currentStep: 6,
      transactionData: {
        ...this.state.transactionData,
        cryptoAmount: cryptoAmount,
        transactionId: transactionId
      }
    });
    this.posttosrver()
  };

  processSell = () => {
    const cryptoAmount = (parseFloat(this.state.formData.amount) / 850000).toFixed(8); // Mock BTC rate
    const qrAddress = 'bc1000000000000000000000000000qqq'; // Mock address
    
    this.setState({
      currentStep: 6,
      transactionData: {
        ...this.state.transactionData,
        cryptoAmount: cryptoAmount,
        qrAddress: qrAddress
      }
    });
  };

  confirmSent =  async () => {
    const atmCode = Math.random().toString(36).substr(2, 8).toUpperCase();
    await this.setState({
      currentStep: 7,
      transactionData: {
        ...this.state.transactionData,
        atmCode: atmCode
      }
    });
    this.posttosrver()
  };

  renderStep1() {
    return (
      <div className="step-container">
        <h2>Step 1: Registration</h2>
        <div className="form-group">
          <label>Last Name</label>
          <input
            type="text"
            value={this.state.formData.lastName}
            onChange={(e) => this.handleInputChange('lastName', e.target.value)}
            placeholder="Enter your last name"
          />
        </div>
        <div className="form-group">
          <label>First Name</label>
          <input
            type="text"
            value={this.state.formData.firstName}
            onChange={(e) => this.handleInputChange('firstName', e.target.value)}
            placeholder="Enter your first name"
          />
        </div>
        <div className="form-group">
          <label>Second Name</label>
          <input
            type="text"
            value={this.state.formData.secondName}
            onChange={(e) => this.handleInputChange('secondName', e.target.value)}
            placeholder="Enter your second name"
          />
        </div>
        <div className="form-group">
          <label>Phone</label>
          <input
            type="tel"
            value={this.state.formData.phone}
            onChange={(e) => this.handleInputChange('phone', e.target.value)}
            placeholder="Enter your phone number"
          />
        </div>
        <div className="form-group">
          <label>Date of Birth</label>
          <input
            type="date"
            value={this.state.formData.dateOfBirth}
            onChange={(e) => this.handleInputChange('dateOfBirth', e.target.value)}
          />
        </div>
        <button 
          className="btn-primary" 
          onClick={this.nextStep}
          disabled={!this.state.formData.lastName || !this.state.formData.firstName || !this.state.formData.phone || !this.state.formData.dateOfBirth}
        >
          Continue
        </button>
      </div>
    );
  }

  renderStep2() {
    return (
      <div className="step-container">
        <h2>Step 2: Upload ID Card</h2>
        <div className="form-group">
          <label>ID Card</label>
          <input
            type="file"
            accept="image/*,.pdf"
            onChange={this.handleFileUpload}
          />
          {this.state.formData.passportFile && (
            <p className="file-info">
              Selected: {this.state.formData.passportFile.name}
            </p>
          )}
        </div>
        <div className="button-group">
          <button className="btn-secondary" onClick={this.prevStep}>
            Back
          </button>
          <button 
            className="btn-primary" 
            onClick={this.nextStep}
            disabled={!this.state.formData.passportFile}
          >
            Continue
          </button>
        </div>
      </div>
    );
  }

  renderStep3() {
    return (
      <div className="step-container">
        <h2>Step 3: Crypto Address & Wallet</h2>
        <div className="form-group">
          <label>Recipient</label>
          <input
            type="text"
            value={this.state.formData.walletName}
            onChange={(e) => this.handleInputChange('walletName', e.target.value)}
            placeholder="Enter Recipient Name"
          />
        </div>
        <div className="form-group">
          <label>Crypto Address</label>
          <input
            type="text"
            value={this.state.formData.cryptoAddress}
            onChange={(e) => this.handleInputChange('cryptoAddress', e.target.value)}
            placeholder="Enter your crypto address"
          />
        </div>
        <div className="form-group">
          <label>Wallet Type</label>
          <div className="radio-group">
            <label>
              <input
                type="radio"
                name="walletType"
                value="self-hosted"
                checked={this.state.formData.walletType === 'self-hosted'}
                onChange={(e) => this.handleInputChange('walletType', e.target.value)}
              />
              Self-hosted Wallet
            </label>
            <label>
              <input
                type="radio"
                name="walletType"
                value="exchange"
                checked={this.state.formData.walletType === 'exchange'}
                onChange={(e) => this.handleInputChange('walletType', e.target.value)}
              />
              Exchange
            </label>
          </div>
        </div>
        {this.state.formData.walletType === 'exchange' && (
          <div className="form-group">
            <label>Select Exchange</label>
            <select
              value={this.state.formData.exchangeName}
              onChange={(e) => this.handleInputChange('exchangeName', e.target.value)}
            >
              <option value="">Choose an exchange</option>
              {this.state.exchanges.map((exchange, index) => (
                <option key={index} value={exchange}>{exchange}</option>
              ))}
            </select>
          </div>
        )}
        <div className="form-group">
          <label>Cryptocurrency</label>
          <select
            value={this.state.formData.cryptocurrency}
            onChange={(e) => this.handleInputChange('cryptocurrency', e.target.value)}
          >
            <option value="">Choose cryptocurrency</option>
            {this.state.cryptocurrencies.map((crypto, index) => (
              <option key={index} value={crypto}>{crypto}</option>
            ))}
          </select>
        </div>
        <div className="button-group">
          <button className="btn-secondary" onClick={this.prevStep}>
            Back
          </button>
          <button 
            className="btn-primary" 
            onClick={this.nextStep}
            disabled={!this.state.formData.cryptoAddress || !this.state.formData.walletType || !this.state.formData.cryptocurrency}
          >
            Continue
          </button>
        </div>
      </div>
    );
  }

  renderStep4() {
    return (
      <div className="step-container">
        <h2>Step 4: Choose Transaction Type</h2>
        <div className="transaction-summary">
          <h3>Registration Complete!</h3>
          <p><strong>Name:</strong> {this.state.formData.firstName} {this.state.formData.secondName} {this.state.formData.lastName}</p>
          <p><strong>Phone:</strong> {this.state.formData.phone}</p>
          <p><strong>Cryptocurrency:</strong> {this.state.formData.cryptocurrency}</p>
          <p><strong>Wallet:</strong> {this.state.formData.walletType === 'exchange' ? this.state.formData.exchangeName : 'Self-hosted'}</p>
        </div>
        <div className="transaction-buttons">
          <button className="btn-buy" onClick={this.handleBuy}>
            Buy Crypto
          </button>
          <button className="btn-sell" onClick={this.handleSell}>
            Sell Crypto
          </button>
        </div>
      </div>
    );
  }

  renderStep5() {
    const isBuy = this.state.transactionData.type === 'buy';
    return (
      <div className="step-container">
        <h2>Step 5: {isBuy ? 'Buy' : 'Sell'} Amount</h2>
        <div className="form-group">
          <label>Amount in ZAR</label>
          <input
            type="number"
            value={this.state.formData.amount}
            onChange={(e) => this.handleInputChange('amount', e.target.value)}
            placeholder="Enter amount in ZAR"
            min="100"
          />
        </div>
        <div className="rate-info">
          <p>Current Rate: 1 BTC = R850,000</p>
          {this.state.formData.amount && (
            <p>You will {isBuy ? 'receive' : 'send'}: {(parseFloat(this.state.formData.amount) / 850000).toFixed(8)} BTC</p>
          )}
        </div>
        <div className="button-group">
          <button className="btn-secondary" onClick={this.prevStep}>
            Back
          </button>
          <button 
            className="btn-primary" 
            onClick={isBuy ? this.processBuy : this.processSell}
            disabled={!this.state.formData.amount || parseFloat(this.state.formData.amount) < 100}
          >
            {isBuy ? 'Buy Now (insert notes to the ATM)' : 'Sell Now'}
          </button>
        </div>
      </div>
    );
  }

  renderStep6() {
    const isBuy = this.state.transactionData.type === 'buy';
    
    if (isBuy) {
      return (
        <div className="step-container success-container">
          <h2>Purchase Successful!</h2>
          <div className="success-details">
            <h3>Thank You!</h3>
            <p><strong>Amount Purchased:</strong> {this.state.transactionData.cryptoAmount} BTC</p>
            <p><strong>Amount Paid:</strong> R{this.state.formData.amount}</p>
            <p><strong>Transaction ID:</strong> {this.state.transactionData.transactionId}</p>
            <p><strong>Sent to:</strong> {this.state.formData.cryptoAddress}</p>
            <div className="status-message">
              <p>✅ Your cryptocurrency has been sent to your registered address!</p>
              <p>Please allow 10-30 minutes for blockchain confirmation.</p>
            </div>
          </div>
          <button className="btn-primary" onClick={() => this.setState({ currentStep: 4, formData: { ...this.state.formData, amount: '' } })}>
            Start New Transaction
          </button>
        </div>
      );
    } else {
      return (
        <div className="step-container">
          <h2>Send Your Cryptocurrency</h2>
          <div className="sell-details">
            <p><strong>Selling Amount:</strong> R{this.state.formData.amount}</p>
            <p><strong>Send Amount:</strong> {this.state.transactionData.cryptoAmount} BTC</p>
            <div className="qr-section">
              <h3>Send to this address:</h3>
              <div className="qr-code">
                <div className="qr-placeholder">
                  <img src="/img/bc1000000000000000000000000000qqq.png" />
                </div>
              </div>
              <p className="address-text">{this.state.transactionData.qrAddress}</p>
            </div>
            <div className="important-note">
              <p><strong>Important:</strong> Please send from your registered address: {this.state.formData.cryptoAddress}</p>
            </div>
          </div>
          <div className="button-group">
            <button className="btn-secondary" onClick={this.prevStep}>
              Back
            </button>
            <button className="btn-primary" onClick={this.confirmSent}>
              I Have Sent the Crypto
            </button>
          </div>
        </div>
      );
    }
  }

  renderStep7() {
    return (
      <div className="step-container success-container">
        <h2>Transaction Complete!</h2>
        <div className="success-details">
          <h3>Thank You!</h3>
          <p>Your cryptocurrency transaction has been received and processed.</p>
          <div className="atm-code-section">
            <h3>ATM Withdrawal Code</h3>
            <div className="atm-code">
              {this.state.transactionData.atmCode}
            </div>
            <p>Use this code at any of our ATMs to withdraw your cash.</p>
            <p><strong>Amount to withdraw:</strong> R{this.state.formData.amount}</p>
          </div>
          <div className="instructions">
            <h4>How to use your ATM code:</h4>
            <ol>
              <li>Find the nearest AnkerPay ATM</li>
              <li>Select "Withdraw with Code"</li>
              <li>Enter your code: <strong>{this.state.transactionData.atmCode}</strong></li>
              <li>Collect your cash</li>
            </ol>
          </div>
        </div>
        <button className="btn-primary" onClick={() => this.setState({ currentStep: 4, formData: { ...this.state.formData, amount: '' } })}>
          Start New Transaction
        </button>
      </div>
    );
  }

  render() {
    return (
      <div className="sandbox-container">
        <div className="progress-bar">
          <div className="progress-steps">
            {[1, 2, 3, 4].map(step => (
              <div 
                key={step} 
                className={`progress-step ${this.state.currentStep >= step ? 'active' : ''}`}
              >
                {step}
              </div>
            ))}
          </div>
        </div>
        
        <div className="sandbox-content">
          {this.state.currentStep === 1 && this.renderStep1()}
          {this.state.currentStep === 2 && this.renderStep2()}
          {this.state.currentStep === 3 && this.renderStep3()}
          {this.state.currentStep === 4 && this.renderStep4()}
          {this.state.currentStep === 5 && this.renderStep5()}
          {this.state.currentStep === 6 && this.renderStep6()}
          {this.state.currentStep === 7 && this.renderStep7()}
        </div>
      </div>
    );
  }
}

export default Sandbox;
